import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose, filter, sortBy, prop, reverse, path } from 'ramda';

import Card from '../../../../../components/Card';
import { apiDeleteUserMembership } from '../../../../../api/membership';
import { handleSuccessBase, handleErrorBase } from '../../../../../util/forms';
import CreateMembershipModal from '../../../../../components/Modal/CreateMembershipModal';

class Memberships extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func,
  };

  state = {
    showModal: false,
  };

  render() {
    const { user, updateUser } = this.props;
    const { showModal } = this.state;
    const sortedMemberships = compose(
      reverse,
      sortBy(prop('year')),
      filter((m) => m.approved === true),
    )(user.userMemberships);

    return (
      <Fragment>
        <Card>
          <Card.Header>
            Memberships
            <button className="btn btn-primary float-right" onClick={() => this.setState({ showModal: true })}>
              Add
            </button>
          </Card.Header>
          <Card.Body>
            {sortedMemberships.length == 0 ? (
              <p>This user does not have any memberships</p>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Type</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {sortedMemberships.map((membership) => (
                    <tr key={membership.id}>
                      <td>{membership.year}</td>
                      <td>{path(['membership', 'name'], membership)}</td>
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            apiDeleteUserMembership(membership.id)
                              .then(({ data }) => updateUser(data))
                              .then(() => handleSuccessBase())
                              .catch((e) => handleErrorBase())
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Body>
        </Card>
        <CreateMembershipModal
          show={showModal}
          user={user}
          onHide={() => this.setState({ showModal: false })}
          updateUser={updateUser}
        />
      </Fragment>
    );
  }
}

export default Memberships;
